module.exports = __webpack_public_path__ + "static/media/calibre.4fbb3daf.svg";